var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project && _vm.pageList && _vm.page)?_c('w-sys-pagelet',{ref:"w-sys-footer-pagelet",attrs:{"root":true,"mode":"runtime","type":"footer","project-config":_vm.project,"config":_vm.page,"page-list":_vm.pageList,"main":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }